import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

import { LogoProps } from "./types";

export const Logo = ({ collapsed, onClick }: LogoProps) => (
  <Link
    to="/"
    className="flex items-center"
    onClick={(e) => {
      if (onClick) {
        e.preventDefault();
        onClick();
      }
    }}
  >
    {collapsed ? (
      // Show mini logo when collapsed
      <img src="/logos/stack-mini.svg" alt="Stack" className="h-8 w-8" />
    ) : (
      // Show full logo when expanded
      <img src="/logos/stack.svg" alt="Stack" className="h-8" />
    )}
  </Link>
);
